import 'styles/apps/personal/components/masthead.scss';
import React from 'react';
import PropTypes from 'prop-types';
import ScrollAnimation from 'library/util/scroll';
import LoadGraph from 'util/hoc/with-data';
import { resolve } from 'library/helpers/path-resolver';
import Qualities from 'apps/personal/components/masthead-qualities';
import CaretSvg from 'library/icons/caret.svg';
// import PersonalHeader from 'components/header';

const AssessmentChooser = ({ assessment }) => (
  !assessment
    ? null
    : (<span>{ assessment.completed_at } {trans`SURVEY`}</span>)
);

AssessmentChooser.propTypes = {
  loading: PropTypes.bool,
  assessment: PropTypes.object
};

class Masthead extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    graph_data: PropTypes.object,
    graph_loading: PropTypes.bool
  }

  state = {
    current_assessment: null
  }

  handleScroll = () => {
    const scrollTop = document.body.scrollTop;
    const innerHeight = window.innerHeight;
    const scrollTime = Math.abs((scrollTop - innerHeight) / innerHeight) * 1000;
    new ScrollAnimation(scrollTop, innerHeight, scrollTime, 'quad.easeInOut');
  }


  _current_assessment=null;
  get current_assessment() {
    const { graph_data } = this.props;
    const assessments = resolve(graph_data, '/account/assessments', []);
    this._current_assessment = assessments.filter(s=>s.scored).sort((a,b)=>new Date(b.completed_at) - new Date(a.completed_at)).shift();

    return this._current_assessment||{};
  }

  render() {
    const {
      graph_loading
    } = this.props;

    return (
      <div className="personal-masthead">
        <div className="personal-masthead-header">
          <AssessmentChooser assessment={this.current_assessment}  />
        </div>
        <div className="personal-masthead-content">
          <Qualities loading={graph_loading} qualities={this.current_assessment.qualities} />
        </div>
        <div className="personal-masthead-scroll">
          <button onClick={this.handleScroll} className="personal-masthead-scroll-button">
            <CaretSvg className="icon" />
          </button>
        </div>
      </div>
    );
  }
}

Masthead.query = `
  query {
    account() {
      assessments (recent: false) {
        id
        progress,
        scored,
        validity_errors,
        validity_score,
        completed_at,
        qualities {
            id
            name
            link_name
            description
            category
        }
      }
    }
  }
`;

export default LoadGraph(Masthead, __LANGUAGE__, 3600);

//<PersonalHeader account={this.props.data} assessment={this.props.current_assessment} />
